import * as React from 'react'
import * as ReactGA from 'react-ga'
import './comment.scss'
import noSupport from "../../images/like.png"
import hasSupport from "../../images/had_support.png"
import defaultPic from "../../images/default_pic.png"
import { IPath, IUseData } from "./interface"
import { Format } from './helper'
import { TabBar } from '../common/tab_bar/tab_bar'
import { ActivityNav } from '../common/activity_nav/activity_nav'
import { ActivitySlide } from '../common/activity_slide/activity_slide'
import { CheckAuth } from "../../utils/auth"
import { defaultAppFn, IShare } from '../../utils/app'
import { Observer } from '../../utils/rx'
import { getCommentList, getUserList, isSupport, creatComment, getActivityDetailInfo, getGroupActivityList } from './api'
import { WXShareConfig } from 'src/utils/config'
import { Api as CommonApi } from '../common/api'
import { IGetActivityInfoResponse } from '../common/interface'

class ActivityComment extends React.Component<IPath, IUseData>{
    private ids: string
    private areaVal: string
    constructor(props: any) {
        super(props);
        this.state = {
            ids: '',
            inputVal: '',
            voteId: '',
            page: 1,
            num: 100,
            commentInfoList: [],
            name: '',
            coverImage: '',
            activityNavList: [],
            currentDetailId: 0,
            canComment: true
        }
    }

    public componentWillMount() {
        this.changeCommonFun()
    }

    public componentWillReceiveProps() {
        this.changeCommonFun()
    }

    public componentDidMount = () => {
        // 监听app分享
        Observer.subscribe('share', async () => {
            const share: IShare = {
                title: `评论_${this.state.name}-上海有色网`,
                content: '',
                image: this.state.coverImage,
                url: window.location.href
            }
            defaultAppFn.Apply('app_share', share)
        })
        ReactGA.pageview(window.location.pathname + window.location.search)
    }

    public componentWillUnmount = () => {
        Observer.unSubscribe('share')
    }

    public changeCommonFun() {
        setTimeout(async () => {
            this.setState({
                currentDetailId: Number(this.props.detailId)
            })
            // 获取活动信息
            const getActivityInfo = await this.getActivityInfo(Number(this.props.groupId))
            getActivityDetailInfo(Number(this.props.detailId)).then(res => {
                if (!res.code) {
                    defaultAppFn.Apply('app_nav', {
                        show: true,
                        back: true,
                        title: res.data.name,
                        share: true
                    })
                    // 微信分享设置
                    WXShareConfig(
                        getActivityInfo.name?`我正在参加《${getActivityInfo.name}》，快来投我一票`:`我正在参加上海有色网投票评选，快来投我一票`,
                        res.data.brief,
                        window.location.href,
                        res.data.share_picture_url
                    )
                    this.setState({
                        name: res.data.name,
                        coverImage: res.data.cover_image
                    })
                }
            })
            // 组的id
            getGroupActivityList(Number(this.props.groupId)).then(res => {
                if (!res.code) {
                    this.setState({
                        activityNavList: Format.groupActivityListToActivityNav(res.data, Number(this.props.groupId))
                    })
                }
            })
            this.setListData()
        }, 0)
    }
    public inputValChange(event: any) {
        this.setState({
            inputVal: event.target.value
        })
    }
    public publishComment = () => {
        CheckAuth.check()
        this.setState({
            canComment: false
        })
        creatComment(this.props.detailId, this.state.inputVal).then(res => {
            if (!res.code) {
                this.setListData()
                this.setState({
                    canComment: true
                })
            } else {
                alert(res.msg)
                this.setState({
                    canComment: true
                })
            }
        })
    }
    public setListData() {
        const userIds: number[] = []
        let getCommentData: any[] = []
        const userInfos: { [index: number]: any } = {}
        getCommentList(this.props.detailId, this.state.page, this.state.num).then(res => {
            if (!res.code && res.data.list.length > 0) {
                getCommentData = res.data.list
                getCommentData.forEach((item: any) => {
                    userIds.push(item.user_id)
                    this.ids = userIds.join(",")
                });
            }
            getUserList(this.ids).then(users => {
                if (!users.code && users.data.infos.length > 0) {
                    users.data.infos.forEach((user: any) => {
                        userInfos[user.id] = user
                    })
                    getCommentData.forEach((item: any) => {
                        const exist = userInfos[item.user_id]
                        if (exist) {
                            item.nickname = exist.nickname
                            item.real_name = exist.real_name
                            item.user_name = exist.user_name
                            item.avatar = exist.avatar
                            item.company_name = exist.company_name
                            item.english_avatar = exist.english_avatar
                            item.hasSupport = false
                        }
                    })
                    this.setState({
                        commentInfoList: getCommentData
                    })
                }
            })
        })
    }
    public handleItemClick(item: any) {
        const newList = this.state.commentInfoList
        let status: number;
        if (item.hasSupport) {
            status = 0
        } else {
            status = 1
        }
        this.support(item.id, status, item).then(res => {
            this.setState({
                commentInfoList: newList
            })
        })
    }
    public support(id: number, num: number, data: any) {
        return new Promise(resolve => {
            isSupport(id, num).then((res: any) => {
                if (!res.code) {
                    if (data.hasSupport) {
                        data.hasSupport = false
                        data.support_num -= 1
                    } else {
                        data.hasSupport = true
                        data.support_num += 1
                    }
                    resolve(data)
                }
            })
        })
    }
    public commentStatus() {
        console.log("接口未调用完成, 不能继续点击！")
    }
    public render() {
        const activityNavList = this.state.activityNavList
        const currentDetailId = this.state.currentDetailId
        const canClickComment = this.state.canComment
        return (
            <div className="comment-container">
                <ActivitySlide url={this.state.coverImage} />
                <div className="activity-nav-container">
                    <ActivityNav
                        data={{
                            activityNavlist: activityNavList,
                            currentKey: currentDetailId
                        }}
                    />
                </div>
                <div className="comment-box">
                    <div className="comment-area">
                        <textarea className="area-word" maxLength={70} placeholder="请留下您的评论，不超过70字" value={this.areaVal} onChange={(e) => this.inputValChange(e)} />
                        <div className="click-comment" onClick={canClickComment ? this.publishComment : this.commentStatus}>评论</div>
                    </div>
                    <div className="comment-list clearfix">
                        <ul>
                            {
                                this.state.commentInfoList.map((item: any) => {
                                    return (
                                        <li className="comment-item" key={item.id}>
                                            <div className="item-top clearfix">
                                                <img className="item-top-img" src={item.avatar ? item.avatar : defaultPic} alt="" />
                                                <span className="item-top-name">{item.nickname ? item.nickname : item.real_name ? item.real_name : item.user_name}</span>
                                                <span className="item-top-num">{item.support_num}</span>
                                                <img className="item-top-noclick" style={{ display: !item.hasSupport ? "block" : "none" }} src={noSupport} onClick={this.handleItemClick.bind(this, item)} alt="" />
                                                <img className="item-top-noclick" style={{ display: item.hasSupport ? "block" : "none" }} src={hasSupport} onClick={this.handleItemClick.bind(this, item)} alt="" />
                                            </div>
                                            <div className="item-bottom">{item.content}</div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
                <TabBar data={{
                    groupId: this.props.groupId,
                    activityId: this.props.detailId,
                    currentText: '评论'
                }} />
            </div>
        )
    }

    private getActivityInfo = (id: number): Promise<IGetActivityInfoResponse['list'][0]> => {
        return new Promise(resolve => {
            let info: IGetActivityInfoResponse['list'][0] = {
                name: ''
            }
            CommonApi.getActivityInfo(id).then(res => {
                if (res.code === 0 && res.data.list && res.data.list.length) {
                    info = res.data.list[0]
                }
                resolve(info)
            })
        })
    }
}

export {
    ActivityComment
}


// WEBPACK FOOTER //
// ./src/components/activity_comment/comment.tsx